// src/utils下创建i18n/index.js
import Vue from 'vue'
import VueI18n from 'vue-i18n'

// 引入各个语言配置文件
import zh from './langs/zh'
import TW from './langs/TW'
import en from './langs/en'
import Thai from './langs/Thai'
import Jap from './langs/Jap'
import Korean from './langs/Kor'
import Vietnamese from './langs/Vie'
import Indonesia from './langs/Rep'
import French from './langs/Fra'
import German from './langs/Ger'

Vue.use(VueI18n)
const lang = JSON.parse(localStorage.getItem('lang')) || 'en'
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
    // 设置默认语言
    locale: lang, // 语言标识
    // 添加多语言（每一个语言标示对应一个语言文件）
    messages: {
        zh,
        TW,
        en,
        Thai,
        Jap,
        Korean,
        Vietnamese,
        Indonesia,
        French,
        German,
    }
})
// 暴露i18n
export default i18n
